// extracted by mini-css-extract-plugin
export default {"app-wrapper":"app-wrapper__T0+3W"};